import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated, getMustChangePassword } from '../services/api';

/**
 * ProtectedRoute component that ensures:
 * 1. User is authenticated
 * 2. User has changed their password (if required)
 */
const ProtectedRoute = ({ children }) => {
  const location = useLocation();

  // Check authentication
  if (!isAuthenticated()) {
    // Redirect to login, preserving the attempted location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user must change password
  if (getMustChangePassword()) {
    // Redirect to reset-password, preserving the attempted location
    return <Navigate to="/reset-password" state={{ from: location }} replace />;
  }

  // User is authenticated and has changed password - allow access
  return children;
};

export default ProtectedRoute;

